<template>
	<div class="progress">
		<div class="progress__bar progress__bar--done" :style="{width:progress + '%'}">
			<div class="progress__bar__shade progress__bar__shade--done"></div>
		</div>
		<div class="progress__bar progress__bar--goal" :style="{width:goal + '%'}">
			<div class="progress__bar__shade progress__bar__shade--goal"></div>
		</div>
		<div class="progress__bar progress__bar--ahead" :style="{width:progress + '%'}">
			<div class="progress__bar__shade progress__bar__shade--ahead"></div>
		</div>
	</div>
</template>

<script>
import PlanningService from '@/services/PlanningService'
export default {
	props: {
		tasks: Array
	},
	data () {
		return {
		}
	},
	methods: {
	},
	computed: {
		goal () {
			return PlanningService.getGoal(this.tasks)
		},
		progress () {
			return PlanningService.getProgress(this.tasks)
			// return Math.min(PlanningService.getProgress(this.tasks), this.goal)
		},
		ahead () {
			return PlanningService.getAhead(this.tasks)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_progress.scss";
</style>
